<template>
  <div class="body-container bank-set" :class="{ 'bank-ok': $route.query.isOk == 1 }">
    <div class="info-text">请准确填写下列信息</div>
    <div class="form-box">
      <div class="row">
        <div class="label">持卡人姓名</div>
        <span class="text">{{ query.name }}</span>
      </div>
      <div class="row" v-if="query.idType">
        <div class="label">证件类型</div>
        <span class="text">{{ CARD_TYPE[query.idType] }}</span>
      </div>
      <div class="row">
        <div class="label">证件号</div>
        <span class="text">{{ query.idNo }}</span>
      </div>
      <div class="row">
        <div class="label">开户银行</div>
        <div @click="!look && (showBankSelect = true)">
          <span class="text" v-if="form.bankText">{{ form.bankText }}</span>
          <span class="text gray" v-else>请选择开户银行</span>
          <i class="icon-youjiantou" v-if="!look"></i>
        </div>
      </div>
      <!-- <div class="row" v-if="query.mechanUserType==1">
        <div class="label">开户支行</div>
        <input v-model="form.accountOpenBranch" :readonly="look" placeholder="请输入" type="text" class="big-input" />
      </div> -->
      <div class="row">
        <div class="label">银行卡号</div>
        <span class="text" v-if="look">{{ form.cardNo }}</span>
        <input v-else v-model="form.cardNo" :readonly="look" placeholder="支持储蓄卡/借记卡" type="number" class="big-input" />
      </div>
      <div class="row">
        <div class="label">银行预留手机号</div>
        <span class="text" v-if="look">{{ form.reservedMobile }}</span>
        <input v-else v-model="form.reservedMobile" :readonly="look" placeholder="请输入" type="number" class="big-input" />
      </div>
      <div class="row" v-if="!look">
        <div class="label">验证码</div>
        <div>
          <input v-model="form.code" placeholder="输入短信验证码" type="tel" class="code-input" oninput="if(value.length>6)value=value.slice(0,6)" />
          <span class="text blue code-btn" :style="{ color: $route.query.isOk == 1 ? '#FF8B00' : '' }" @click="checkCode" v-if="codeIndex == CODE_SIZE"
            >获取验证码</span
          >
          <span class="text code-btn" v-else>{{ codeIndex }}S</span>
        </div>
      </div>
    </div>
    <div class="radio-box">您的银行卡信息仅作为提现服务使用，您的信息将被严格保密，为了保护您的账户资金安全，提交或修改银行卡信息需校验联系人手机号。</div>
    <van-button round class="form-btn" @click="clearForm" v-if="look">更换绑定银行卡</van-button>
    <van-button round class="form-btn" @click="submit" v-else>保存</van-button>

    <van-popup v-model="showBankSelect" class="date-popup" position="bottom">
      <van-picker title="请选择开户银行" show-toolbar :columns="bankList" @confirm="onConfirm" @cancel="showBankSelect = false" />
    </van-popup>
    <validCodeModal ref="validCodeModal" @success="timerStart" :color="$route.query.isOk == 1 ? 'yellow' : ''"></validCodeModal>
  </div>
</template>
<script>
const CODE_SIZE = 60;
import { codeTools, common } from '@/api/mixins';
import validCodeModal from '@/components/validCodeModal';
//当前实例组件
export default {
  mixins: [codeTools, common],
  components: { validCodeModal },
  data: () => ({
    look: false,
    radio: false,
    loading: true,
    showBankSelect: false,
    bankList: [],
    bankData: [],
    form: {},
    query: {},
    CARD_TYPE: {}
  }),
  mounted() {
    if (!this.checkLogin()) {
      return;
    }
    this.getDicByType({
      type: 'CARD_TYPE'
    }).then(res => {
      this.CARD_TYPE = res;
    });
    this.getUserInfo();
    this.getBankData();
    this.$weixin.hideMenu();
  },
  methods: {
    checkCode() {
      if (this.codeIndex != this.CODE_SIZE) {
        return;
      }
      if (!this.form.reservedMobile || !this.$regulars.isPhone(this.form.reservedMobile)) {
        this.$notice.msg('请输入正确的手机号');
        return;
      }
      this.$refs.validCodeModal.open({
        requestUrl: '/api/user/sendCodeV2',
        params: {
          mobile: this.form.reservedMobile
        }
      });
    },
    clearForm() {
      this.$set(this.form, 'bank', '');
      this.$set(this.form, 'bankText', '');
      this.$set(this.form, 'cardNo', '');
      this.$set(this.form, 'reservedMobile', '');
      this.$set(this.form, 'code', '');
      this.look = false;
    },
    //获取银行卡信息
    getBankInfo() {
      this.$http({
        type: 'GET',
        url: '/api/userWithdrawLog/read/info',
        data: {}
      }).then(res => {
        const data = res.data;
        this.$set(this.form, 'bank', data.bankCode);
        this.$set(this.form, 'bankText', data.bank);
        this.$set(this.form, 'cardNo', data.cardNo);
        this.$set(this.form, 'reservedMobile', res.data.reservedMobile);
      });
    },
    getUserInfo() {
      this.loading = true;
      this.$http({
        type: 'GET',
        url: '/api/userBase/getUserInfo',
        data: {}
      })
        .then(res => {
          this.loading = false;
          this.query = res.data;
          if (this.query.hasBankCard) {
            this.look = true;
            this.getBankInfo();
          } else {
            this.$set(this.form, 'bank', '');
            this.$set(this.form, 'bankText', '');
            this.$set(this.form, 'cardNo', '');
            this.$set(this.form, 'reservedMobile', '');
            this.$set(this.form, 'code', '');
            this.look = false;
          }
          this.setUser({ qualificationFlag: this.query.qualificationFlag });
        })
        .catch(e => {
          this.loading = false;
        });
    },
    // 获取银行数据
    getBankData() {
      this.$http({
        type: 'POST',
        url: '/api/dic/read/dicList',
        data: { code: 'BANK_TYPE' }
      }).then(res => {
        this.bankData = res.data;
        this.bankList = [];
        this.bankData.forEach(item => {
          this.bankList.push(item.txt);
        });
      });
    },
    // 选择开户行
    onConfirm(text) {
      this.bankData.forEach(item => {
        if (item.txt == text) {
          this.$set(this.form, 'bank', item.value);
          this.$set(this.form, 'bankText', text);
          this.showBankSelect = false;
        }
      });
    },
    yz() {
      if (!this.form.bankText) {
        this.$notice.msg('请选择开户银行');
        return;
      }
      if (!this.$regulars.isBankCard(this.form.cardNo)) {
        this.$notice.msg('请输入正确的银行卡号');
        return;
      }
      // if(this.query.mechanUserType==1){//机构
      //   if (!this.form.accountOpenBranch) {
      //     this.$notice.msg("请输入开户行");
      //     return;
      //   }
      // }
      if (!this.$regulars.isPhone(this.form.reservedMobile)) {
        this.$notice.msg('请输入正确的手机号');
        return;
      }
      if (!this.form.code) {
        this.$notice.msg('请输入验证码');
        return;
      }
      if (this.form.code.toString().length != 6) {
        this.$notice.msg('请输入6位验证码');
        return;
      }

      return true;
    },
    submit() {
      if (!this.yz()) {
        return;
      }
      if (this.loading) return;
      this.loading = true;
      this.$http({
        type: 'POST',
        url: '/api/userBase/bindBankCard',
        data: this.form
      })
        .then(res => {
          this.$notice.msg('保存成功，3秒后自动跳转');
          window.setTimeout(() => {
            this.loading = false;
            if (this.$config.isApp) {
              if (this.$route.query.back == 1) {
                this.$router.back();
              } else {
                this.$app.closeWebView();
              }
            } else {
              history.go(-1);
            }
          }, 3000);
        })
        .catch(() => {
          this.loading = false;
        });
    }
    // getCode() {
    //   this.timerStart();
    //   let obj = JSON.parse(localStorage.getItem("jzy_user"));

    //   console.log(obj.userId);
    //   console.log(this.query);
    //   this.$http({
    //     type: "GET",
    //     url: "/api/user/sendCodeV2",
    //     data: {
    //       mobile: this.form.reservedMobile
    //     }
    //   })
    //     .then(res => {})
    //     .catch(e => {
    //       window.clearInterval(this.timer);
    //       this.codeIndex = CODE_SIZE;
    //     });
    // }
  }
};
</script>
<style lang="scss" scoped>
@import './bankSet.scss';
</style>
